<template>
  <div>
    <v-card class="mb-2 light-green lighten-4" @click="siteClick">
      <v-card-text>
        <div class="d-flex">
          <div>
            <div>{{ item.Description }}</div>
          </div>
          <v-spacer />
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-bind="attrs"
                  v-on="on"
                  @click="siteClick"
                >
                  <v-icon :color="feature.sites.color">
                    {{ feature.sites.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Site</span>
            </v-tooltip>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { ref } from 'vue'
import { feature } from '@/use/Constants'
export default {
  name: 'SiteListItemCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const initForm = async () => {
      await loadSelectLists()
    }

    const loadSelectLists = async () => {}

    const siteClick = () => {
      context.emit('click', props.item.SiteId)
    }

    initForm()
    return {
      feature,
      siteClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
